import { render, staticRenderFns } from "./ProductMaterialMixtureCategorySelector.vue?vue&type=template&id=155bd84e&"
import script from "./ProductMaterialMixtureCategorySelector.vue?vue&type=script&lang=js&"
export * from "./ProductMaterialMixtureCategorySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports